import { useCallback, useMemo, useState } from 'react'

export const usePopover = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [activeId, setActiveId] = useState(null)

  const onClick = useCallback((event, id) => {
    event.stopPropagation()
    const currentTarget = event.currentTarget
    setAnchorEl(currentTarget)
    setActiveId(id)
  }, [])

  const onOpen = useCallback(({ anchorEl = null, id }) => {
    if (anchorEl) {
      setAnchorEl(anchorEl)
    }
    setActiveId(id)
  }, [])

  const onClose = useCallback(() => {
    setActiveId(null)
    setAnchorEl(null)
  }, [])

  const bindTrigger = useCallback(
    ({ id, disabled = false }) => ({
      onClick: (event) => !disabled && onClick(event, id),
      'data-trigger-id': id,
      disabled,
    }),
    [],
  )

  const bindPopover = useCallback(
    (state = {}) => ({
      ...state,
      activeId,
      anchorEl,
      onClose,
    }),
    [activeId, anchorEl],
  )

  const isOpen = useMemo(() => activeId !== null, [activeId])

  const usePopupState = useCallback(
    (state = {}) => ({
      ...state,
      isOpen,
      anchorEl,
      activeId,
      open: () => onOpen(state),
      close: onClose,
    }),
    [isOpen, anchorEl, activeId],
  )

  return {
    bindTrigger,
    bindPopover,
    usePopupState,
  }
}
